<template lang="">
    <el-upload
        v-model:file-list="uploaderObj.fileLists"
        class="upload-demo"
        :class="{ 'img-slot': needSlot }"
        :action="requestDomain + '/api/attachments/uploadOtherFiles'"
        :on-success="handleSuccess"
        :on-remove="handleRemove"
        :limit="limits"
        list-type="picture-card"
        :multiple="limits === 1 ? false : true"
        drag
        ref="refUpload"
    >
        <el-icon class="el-icon--upload"><upload-filled /></el-icon>
    </el-upload>
</template>
<script setup>
import { ref, reactive } from 'vue';
import { Delete, Plus, UploadFilled } from '@element-plus/icons-vue';
import { requestDomain } from '../../package.json';
const props = defineProps({ fileLists: Array, limits: Number, needSlot: Boolean });
const emit = defineEmits(['uploadBack']);
const refUpload = ref();
const uploaderObj = reactive({
    fileLists: props.fileLists
});
const handleSuccess = e => {
    console.log(e, 't');
    emit('uploadBack', e, false);
};
const handleRemove = e => {
    refUpload.value.clearFiles();
    emit('uploadBack', e, true);
};

const handlePictureCardPreview = file => {
    // dialogImageUrl.value = file.url;
    // dialogVisible.value = true;
};

const handleDownload = file => {
    console.log(file);
};
</script>
<style lang="scss">
.upload-demo,
.upload-demo .el-upload-dragger {
    width: 148px;
    height: 148px;
}
.upload-demo {
    margin-right: 8px;
}
.img-slot .el-upload-list {
    display: none;
}
.el-upload-list__item-thumbnail {
    width: 100px;
    height: 100px;
}
.el-upload-list__item-actions {
    position: absolute;
    width: 100px;
    height: 100px;
    left: 0;
    top: 0;
    cursor: default;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s;
}
.el-upload-list__item-actions:hover {
    opacity: 1;
    span {
        display: inline-flex;
        margin-right: 1rem;
        cursor: pointer;
    }
}
.el-upload-list__item-delete {
    position: static;
    font-size: inherit;
    color: inherit;
}
</style>
